import getConfig from 'next/config';
import { NextSeo } from 'next-seo';
import React from 'react';

const { publicRuntimeConfig } = getConfig();
const { NEXT_PUBLIC_DOMAIN } = publicRuntimeConfig;

export default function Health() {
  const title = 'USREM | Health Check';
  const url = NEXT_PUBLIC_DOMAIN;

  return (
    <>
      <NextSeo
        noindex
        nofollow
        title={title}
        canonical={url}
        openGraph={{
          title: title,
          url: url
        }}
      />
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {},
    revalidate: 600
  };
}
